import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { categoryBySlug } from "../data/categories.js";

const descriptions = {
  "/": "ContainX supplies restaurants across Maryland, Washington, DC, and Northern Virginia with takeout containers, cups, bags, foil, gloves, and more.",
  "/products": "Browse restaurant packaging, takeout containers, cups, bags, aluminum pans, compostable products, and food-service supplies from ContainX.",
  "/about": "Learn about ContainX and our local restaurant-supply delivery routes across Maryland, Washington, DC, and Northern Virginia.",
  "/contact": "Contact ContainX for restaurant packaging, bulk orders, product availability, samples, and local DMV delivery.",
  "/request-quote": "Request pricing and availability for restaurant packaging and food-service supplies from ContainX.",
};

const setMeta = (selector, attribute, value) => {
  let element = document.head.querySelector(selector);
  if (!element) { element = document.createElement("meta"); document.head.appendChild(element); }
  Object.entries(attribute).forEach(([key, entry]) => element.setAttribute(key, entry));
  element.setAttribute("content", value);
};

const Seo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const parts = pathname.split("/").filter(Boolean);
    const category = categoryBySlug[parts[0]];
    const product = category?.products.find((entry) => entry.slug === parts[1]);
    const label = product?.name || category?.name;
    const title = pathname === "/" ? "ContainX | Restaurant Packaging & Supplies in the DMV" : `${label || ({ products: "Products", about: "About Us", contact: "Contact Us", "request-quote": "Request a Quote" }[parts[0]]) || "Page Not Found"} | ContainX`;
    const description = descriptions[pathname] || product?.description || category?.description || "Restaurant packaging and food-service supplies from ContainX in the DMV.";
    const canonical = `https://containx.co${pathname === "/" ? "/" : pathname.replace(/\/$/, "")}`;

    document.title = title;
    setMeta('meta[name="description"]', { name: "description" }, description);
    setMeta('meta[property="og:title"]', { property: "og:title" }, title);
    setMeta('meta[property="og:description"]', { property: "og:description" }, description);
    setMeta('meta[property="og:url"]', { property: "og:url" }, canonical);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = canonical;
  }, [pathname]);

  return null;
};

export default Seo;
